export type ShouldReenterAutoscrollParams = {
    pauseLatched: boolean
    nearBottom: boolean
    isUserScrollDown: boolean
}

export const shouldReenterAutoscroll = (params: ShouldReenterAutoscrollParams): boolean => {
    const { pauseLatched, nearBottom, isUserScrollDown } = params

    return nearBottom && (!pauseLatched || isUserScrollDown)
}

export type ShouldEnterAutoscrollAfterFontSizeChangeParams = {
    pauseLatched: boolean
    nearBottom: boolean
}

export const shouldEnterAutoscrollAfterFontSizeChange = (params: ShouldEnterAutoscrollAfterFontSizeChangeParams): boolean => {
    const { pauseLatched, nearBottom } = params

    return nearBottom && !pauseLatched
}
